module.exports = __webpack_public_path__ + "static/img/so6_1.749e1b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution/pic/so6_1.jpg
// module id = tEJd
// module chunks = 11